module.exports = __webpack_public_path__ + "img/full7-min.3f318883.png";